<script>
  import { onMount } from 'svelte';
  import { navigate, useLocation } from 'svelte-routing';
  import { isUserAuthenticated } from './utils';

  let isAuthenticated = false;

  const location = useLocation();

  onMount(async () => {
    isAuthenticated = isUserAuthenticated();

    if (!isAuthenticated) {
      navigate('/login', {
        state: {
          from: $location.pathname,
          utm_source: new URLSearchParams($location.search).get('utm_source'),
        },
        replace: true,
      });
    }
  });
</script>

{#if isAuthenticated}
  <slot />
{/if}
